import { useAccordionItemContext } from '../contexts/accordion-item-context';
import { useAccordionToggle } from '../simple-accordion-summary';

export const SimpleAccordionItemContainer = ({
	className,
	hasSummary,
	children
}: {
	className?: string;
	hasSummary: boolean;
	children: React.ReactNode;
}) => {
	const { expanded } = useAccordionItemContext();
	const handleClick = useAccordionToggle();
	
	return (
		<div 
			className={className}
			data-open={expanded}
			onClick={hasSummary ? undefined : handleClick}
		>
			{children}
		</div>
	);
};